import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'

const messages = {
  zh,
  en
}

const i18n = createI18n({
  locale: localStorage.getItem('locale') || 'zh',
  fallbackLocale: 'zh',
  messages,
  legacy: true
})

export default i18n

